// Time off over bookings (8 Oct 2026): before leave or a block is saved,
// the server lists the bookings it lands on (repeat visits included), so
// the panel can show them with Move and Message. Pure, for tests.
import moment from 'moment'
import { dateSaid, minutesSaid } from './repeat'

// The list from a preview, create or update response. null means it
// couldn't be checked (say nothing); [] means nothing is in the way.
export const affectedFrom = (res) => {
  const body = res && res.data !== undefined ? res.data : res
  const data = body && (body.responseData !== undefined ? body.responseData : body)
  const list = data && data.affectedBookings
  return Array.isArray(list) ? list : null
}

// The last day checked, for a repeating block
export const affectedUntil = (res) => {
  const body = res && res.data !== undefined ? res.data : res
  const data = body && (body.responseData !== undefined ? body.responseData : body)
  return (data && data.affectedBookingsUntil) || null
}

// "This lands on 3 bookings"
export const affectedTitle = list => `This lands on ${list.length} booking${list.length === 1 ? '' : 's'}`

// The line under it. Nothing moves by itself, so it says so.
export const affectedLine = (list, until) => {
  const repeats = list.filter(b => b.seriesId).length
  const parts = ['They stay booked until you move them.']
  if (repeats) parts.push(repeats === list.length ? (repeats === 1 ? 'It’s a repeat visit.' : 'All are repeat visits.') : `${repeats} ${repeats === 1 ? 'is a repeat visit' : 'are repeat visits'}.`)
  if (until) parts.push(`Checked up to ${moment(until, 'YYYY-MM-DD').format('D MMM YYYY')}.`)
  return parts.join(' ')
}

// One row: who, when and what
export const affectedRow = (b) => ({
  id: String(b.bookingId),
  who: (b.client && String(b.client.name || '').trim()) || 'Walk-in',
  when: `${dateSaid(b.date)}, ${minutesSaid(Number(b.start))} to ${minutesSaid(Number(b.end))}`,
  what: (b.services || []).filter(Boolean).join(', '),
  repeat: !!b.seriesId,
  canMessage: !!(b.client && b.client._id),
})

// By day, in date then time order, for a long leave
export const affectedByDay = (list) => {
  const days = []
  ;[...(list || [])]
    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : Number(a.start) - Number(b.start)))
    .forEach((b) => {
      const last = days[days.length - 1]
      if (last && last.date === b.date) last.rows.push(b)
      else days.push({ date: b.date, rows: [b] })
    })
  return days
}

// The preview's request for the panel's choices, or null when there's
// nothing to check (no stylist yet, a room, an event that still takes
// bookings, or times that don't make sense)
export const previewFor = ({ isLeave, staffId, resourceId, startDate, endDate, startMinutes, endMinutes, isBookingAllowed }) => {
  if (!staffId || resourceId || !startDate) return null
  if (isLeave) {
    const from = moment(startDate).format('YYYY-MM-DD')
    const to = moment(endDate || startDate).format('YYYY-MM-DD')
    if (to < from) return null
    return { kind: 'leave', params: { hairdresserId: staffId, startDate: from, endDate: to } }
  }
  if (isBookingAllowed) return null
  if (startMinutes == null || endMinutes == null || !(endMinutes > startMinutes)) return null
  return { kind: 'event', params: { userId: staffId, date: moment(startDate).format('YYYY-MM-DD'), startTime: startMinutes, endTime: endMinutes, isBookingAllowed: false, repeatType: 'doesNotRepeat' } }
}

// Same request, same answer: a key to tell when the choices changed
export const previewKey = p => (p ? JSON.stringify(p) : '')

// After saving, when the list wasn't shown first (the preview didn't
// answer in time, or failed): the toast says what it landed on
export const savedWords = (what, list) => (list && list.length
  ? `${what}. It lands on ${list.length} booking${list.length === 1 ? '' : 's'}. They stay booked until you move them.`
  : what)
